export enum ErrorCode {
  ACTIVITY_DOES_NOT_EXIST = 'E_ACTIVITY_DOES_NOT_EXIST',
  FAILED_TO_ENABLE_NETWORK = 'E_FAILED_TO_ENABLE_NETWORK',
  FAILED_TO_REMOVE_NETWORK = 'E_FAILED_TO_REMOVE_NETWORK',
  INVALID_WIFI_CONFIGURATION = 'E_INVALID_WIFI_CONFIGURATION',
  UNKNOWN_ERROR = 'E_UNKNOWN_ERROR',
  USER_REJECTED = 'E_USER_REJECTED',
  PERMISSION_DENIED = 'E_PERMISSION_DENIED',
  RUNNING_ON_SIMULATOR = 'E_RUNNING_ON_SIMULATOR',
  API_ERROR_UNAUTHORIZED = 'E_API_ERROR_UNAUTHORIZED',
  API_ERROR_BAD_REQUEST = 'E_API_ERROR_BAD_REQUEST',
  API_ERROR_INTERNAL_SERVER_ERROR = 'E_API_ERROR_INTERNAL_SERVER_ERROR',
  API_ERROR = 'E_API_ERROR',
}
